import React, { Component } from "react";
import Table from "@material-ui/core/Table";
import TableRow from "@material-ui/core/TableRow";
import TableHead from "@material-ui/core/TableHead";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import TableFooter from "@material-ui/core/TableFooter";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";

import { withStyles } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next";
const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },
  table: {
    border: "1px solid black",
    margin: "20px",
    width: 700,
  },
  table1: {
    margin: "20px",
    width: "100%",
  },

  boldCell: {
    fontWeight: "bold",
    fontSize: 14,
  },

  boldCenterCell: {
    fontWeight: "bold",
    fontSize: 14,
    align: "center",
  },
  paper: {
    height: 550,
    width: "100%",
    marginTop: theme.spacing.unit * 3,
    overflow: "auto",
  },
});

class GenericReportDetails extends Component {
  render() {
    const { classes } = this.props;
    let { t } = this.props;
    let report = this.props.report;
    let columns = this.props.report.columns;
    return (
      <div>
        <Paper className={classes.paper}>
          {this.props.report.groupAccounts && (
            <div>
              {report.accountData.map((account, index) => {
                return (
                  <div>
                    {index > 0 && (
                      <div style={{ pageBreakBefore: "always" }}></div>
                    )}
                    {(report.repeatTitle || index === 0) && (
                      <div style={{ marginTop: 30, marginLeft: 20 }}>
                        <Typography variant="headline">
                          &nbsp;{report.title}
                        </Typography>
                      </div>
                    )}
                    <table className={classes.table1}>
                      <Paper elevation={0} marginLeft={20}>
                        <tr>
                          <td style={{ width: "120px" }}>
                            {" "}
                            <strong>&nbsp;{t("reportDate.label")}:</strong>
                          </td>
                          <td style={{ width: "330px" }}>
                            {" "}
                            {report.dateCreated}
                          </td>
                          <td style={{ width: "300px" }}>
                            {" "}
                            <strong>{t("createdBy.label")}:</strong>{" "}
                            &nbsp;&nbsp;&nbsp;{report.userName}
                          </td>
                        </tr>
                        <br />
                        <tr>
                          <td style={{ width: "350px" }}>
                            <strong>&nbsp;{t("companyName.header")}</strong>
                          </td>
                          <td style={{ width: "200px" }}>
                            <strong>{t("transit.header")}</strong>
                          </td>
                          <td style={{ width: "200px" }}>
                            <strong>{t("account.header")}</strong>
                          </td>
                        </tr>
                        <tr>
                          <td>&nbsp;{report.companyName}</td>
                          <td>{account.transit}</td>
                          <td>{account.account}</td>
                        </tr>
                      </Paper>
                    </table>
                    {report.description !== null &&
                      report.description.length > 0 && (
                        <div style={{ marginTop: 20, marginLeft: 20 }}>
                          <Typography variant="h6">
                            &nbsp;{report.description}
                          </Typography>
                        </div>
                      )}
                    <Table>
                      <TableHead>
                        <TableRow>
                          {columns.map((column, index1) => {
                            return <TableCell key={index1}>{column}</TableCell>;
                          })}
                        </TableRow>
                      </TableHead>
                      {account.numRecords > 0 && (
                        <TableBody>
                          {account.records.map((record, index2) => {
                            return (
                              <TableRow key={index2}>
                                {record.values.map((value) => {
                                  return <TableCell>{value}</TableCell>;
                                })}
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      )}
                      {account.numRecords === 0 && (
                        <TableBody>
                          <TableRow>
                            <TableCell colSpan={columns.length}>
                              {t("noData.label")}
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      )}

                      {report.showReportSummary &&
                        index === report.accountData.length - 1 && (
                          <TableFooter>
                            <TableRow>
                              <TableCell
                                style={{ fontWeight: "bold", fontSize: 14 }}
                              >
                                {t("reportTotals.label")}
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              {report.totalColumnSummary.map((value) => {
                                return (
                                  <TableCell
                                    style={{ fontWeight: "bold", fontSize: 14 }}
                                  >
                                    {value}
                                  </TableCell>
                                );
                              })}
                            </TableRow>
                          </TableFooter>
                        )}
                      {report.showGroupSummary && account.numRecords > 0 && (
                        <TableFooter>
                          <TableRow>
                            <TableCell
                              style={{ fontWeight: "bold", fontSize: 14 }}
                            >
                              {t("accountTotals.label")}
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            {account.columnSummary.map((value) => {
                              return (
                                <TableCell
                                  style={{ fontWeight: "bold", fontSize: 14 }}
                                >
                                  {value}
                                </TableCell>
                              );
                            })}
                          </TableRow>
                        </TableFooter>
                      )}
                    </Table>
                  </div>
                );
              })}
            </div>
          )}
          {!this.props.report.groupAccounts && (
            <div>
              {report.description !== null && report.description.length > 0 && (
                <div style={{ marginTop: 20, marginLeft: 20 }}>
                  <Typography variant="h6">
                    &nbsp;{report.description}
                  </Typography>
                </div>
              )}
              <br></br>
              <table>
                <Paper elevation={0} marginLeft={20}>
                  <tr>
                    <td width="200">
                      {" "}
                      <strong>{t("reportDate.label")}:</strong>
                    </td>
                    <td width="300">&nbsp;{report.dateCreated}</td>
                    <td width="200">
                      {" "}
                      <strong>{t("createdBy.label")}:</strong>
                    </td>
                    <td width="300">&nbsp;{report.userName}</td>
                    <td width="200">
                      <strong>{t("companyName.header")}:</strong>
                    </td>
                    <td width="300">&nbsp;{report.companyName}</td>
                  </tr>
                </Paper>
              </table>
              <br></br>
              <Table>
                <TableHead>
                  <TableRow>
                    {columns.map((column, index) => {
                      return (
                        <TableCell key={index}>
                          <strong>{column}</strong>
                        </TableCell>
                      );
                    })}
                  </TableRow>
                </TableHead>
                {report.totalRecords > 0 && (
                  <TableBody>
                    {report.records.map((record, index1) => {
                      return (
                        <TableRow key={index1}>
                          {record.values.map((value) => {
                            return <TableCell>{value}</TableCell>;
                          })}
                        </TableRow>
                      );
                    })}
                  </TableBody>
                )}
                {report.totalRecords === 0 && (
                  <TableBody>
                    <TableRow>
                      <TableCell colSpan={columns.length}>
                        {t("noData.label")}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}

                {report.showReportSummary && (
                  <TableFooter>
                    <TableRow>
                      <TableCell style={{ fontWeight: "bold", fontSize: 14 }}>
                        {t("reportTotals.label")}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      {report.totalColumnSummary.map((value) => {
                        return (
                          <TableCell
                            style={{ fontWeight: "bold", fontSize: 14 }}
                          >
                            {value}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  </TableFooter>
                )}
              </Table>
            </div>
          )}
        </Paper>
      </div>
    );
  }
}

export default withTranslation()(withStyles(styles)(GenericReportDetails));
